
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mitra",
      function () {
        return require("private-next-pages/mitra/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mitra"])
      });
    }
  